<template>
  <v-container>
    <v-card class="px-2">
      <input
        id="user-id"
        type="hidden"
        v-model="sessao.usuario"
      >
      <input
        id="proc-uuid"
        type="hidden"
        v-model="sessao.uuid"
      >
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codigo"
            label="Código"
            dense
            outlined
            @change="loadSessao()"
          >
            <v-btn
              class="btn-outer-right pa-0"
              slot="append"
              color="success"
              tile
              @click.prevent="loadDialog"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="3"
          lg="2"
          v-if="codigo"
        >
          <v-checkbox
            v-model="sessao.inativar"
            label="Inativar sessao?"
            color="success"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          colls="12"
          lg="2"
          md="5"
          sm="12"
        >
          <v-text-field
            label="Nº da sessão:"
            v-model="sessao.nr_sessao"
            required
            dense
            outlined
          >
          </v-text-field>
        </v-col>
        <v-col
          colls="12"
          lg="2"
          md="5"
          sm="12"
        >
          <v-autocomplete
            v-model="sessao.reuniao"
            clearable
            :items="reunioes"
            dense
            outlined
            title="Reunião"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-card flat>
        <v-tabs
          background-color="primary"
          dark
          v-model="tabs"
          class="mb-4"
        >
          <v-tab>
            <v-icon class="mr-1">
            </v-icon>
            Informações gerais
          </v-tab>
          <v-tab
            @click="loadVereadores()"
            :disabled="!sessao.id"
          >
            <v-icon class="mr-1">
            </v-icon>
            Quórum
          </v-tab>
          <v-tab
            @click="loadOrdens()"
            :disabled="!sessao.id"
          >
            <v-icon class="mr-1">
            </v-icon>
            Ordem do dia
          </v-tab>
          <v-tab
            @click="loadPresenca()"
            :disabled="!sessao.id"
          >
            <v-icon class="mr-1">
            </v-icon>
            Iniciar
          </v-tab>
          <v-tab :disabled="!sessao.iniciado">
            <v-icon class="mr-1">
            </v-icon>
            Finalizar
          </v-tab>
          <v-tab :disabled="!sessao.id">
            <v-icon class="mr-1">
            </v-icon>
            Mídias
          </v-tab>
          <v-tab
            @click="loadAnexos"
            :disabled="!sessao.id"
          >
            <v-icon class="mr-1">
              mdi-paperclip
            </v-icon>
            Anexos
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-row>
                      <v-col
                        colls="12"
                        lg="4"
                        md="6"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="sessao.uid_legislatura"
                          :items="legislaturas"
                          label="Legislatura:"
                          dense
                          outlined
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        colls="12"
                        lg="2"
                        md="6"
                        sm="12"
                      >
                        <v-text-field
                          label="Ano da sessão :"
                          v-model="sessao.ano"
                          required
                          dense
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        colls="12"
                        lg="4"
                        md="6"
                        sm="12"
                      >
                        <v-autocomplete
                          label="Tipo de sassão:"
                          v-model="sessao.uid_tipo"
                          :items="tipos"
                          dense
                          outlined
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        colls="12"
                        lg="10"
                        md="12"
                        sm="12"
                      >
                        <v-text-field
                          label="Título da sessão :"
                          v-model="sessao.titulo"
                          required
                          dense
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col colls="12">
                        <v-card class="pa-2">
                          <ckeditor
                            :editor="editor"
                            v-model="sessao.ds_sessao"
                            :config="editorConfig"
                          ></ckeditor>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card
              flat
              class="py-2"
            >
              <v-data-table
                :headers="headerVereador"
                :items="vereadores"
                fixed-header
                height="350px"
                dense
                hide-default-footer
                class="elevation-1"
              >
                <template v-slot:[`item.presenca`]="{ item }">
                  <v-checkbox
                    v-model="item.presenca"
                    color="success"
                    dense
                    style="height: 30px;"
                  >
                  </v-checkbox>
                </template>
                <template v-slot:[`item.uid_justificativa`]="{ item }">
                  <v-autocomplete
                    v-model="item.uid_justificativa"
                    :items="justificativa"
                    clearable
                    dense
                    solo
                    style="height: 30px; max-width: 180px;"
                    class="mb-2"
                  >
                  </v-autocomplete>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  v-if="sessao.quorum === 0"
                  color="success"
                  class="ml-1 mb-3"
                  @click="loadAddVereador"
                >
                  <v-icon left>
                    mdi-plus
                  </v-icon>
                  Add vereadores
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card
              flat
              class="py-2"
            >
              <v-data-table
                :headers="headerOrdem"
                :items="ordens"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    disabled
                    large
                    color="success"
                    class="mr-2"
                    @click.prevent="loadSessao(item)"
                  >
                    mdi-arrow-right-bold-box
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-start">
                <v-btn
                  color="success"
                  class="ml-1 mb-3"
                  v-if="sessao.orden_dia === 0"
                  @click="addOrdemDia"
                >
                  <v-icon left>
                    mdi-archive-plus
                  </v-icon>
                  Add Ordem do dia
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-row>
                      <v-col
                        colls="12"
                        lg="3"
                        md="4"
                        sm="12"
                      >
                        <v-text-field
                          v-model="sessao.presente"
                          label="Total de presenças :"
                          dense
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        colls="12"
                        lg="3"
                        md="4"
                        sm="12"
                      >
                        <v-text-field
                          v-model="sessao.ausente"
                          label="Total de faltas :"
                          dense
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        colls="12"
                        lg="3"
                        md="4"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="sessao.uid_situacao"
                          :items="situacoes"
                          label="Situacao da sessao :"
                          dense
                          outlined
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        colls="12"
                        lg="3"
                        md="6"
                        sm="12"
                      >
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="databe"
                              v-model="data_abe"
                              label="Data de abertura.:"
                              dense
                              outlined
                              @blur="mudaDataA"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date0"
                            @input="dateA"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        colls="12"
                        lg="3"
                        md="6"
                        sm="12"
                      >
                        <v-text-field
                          label="Hora abertura :"
                          class="mb-2"
                          type="time"
                          v-model="sessao.hora_inicio"
                          dense
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        lg="2"
                      >
                        <v-checkbox
                          :disabled="sessao.presente === 0"
                          v-model="sessao.iniciado"
                          label="Iniciar sessao?"
                          color="success"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-row>
                      <v-col
                        colls="12"
                        lg="3"
                        md="6"
                        sm="12"
                      >
                        <v-menu
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="datenc"
                              v-model="data_enc"
                              label="Data de encerramento.:"
                              dense
                              outlined
                              @blur="mudaDataB"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date1"
                            @input="dateB"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        colls="12"
                        lg="3"
                        md="6"
                        sm="12"
                      >
                        <v-text-field
                          label="Hora abertura :"
                          class="mb-2"
                          type="time"
                          v-model="sessao.hora_encerramento"
                          dense
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        lg="2"
                      >
                        <v-checkbox
                          v-model="sessao.encerrado"
                          label="Encerrar sessao?"
                          color="success"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-row>
                      <v-col
                        colls="12"
                        lg="10"
                        md="12"
                        sm="12"
                      >
                        <v-text-field
                          label="Link do audio da sessão :"
                          v-model="sessao.url_audio"
                          clearable
                          dense
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        colls="12"
                        lg="10"
                        md="12"
                        sm="12"
                      >
                        <v-text-field
                          label="Link do vídeo da sessão :"
                          v-model="sessao.url_video"
                          clearable
                          dense
                          outlined
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-data-table
                      :headers="headerAnexo"
                      :items="anexos"
                      :search="search"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          medium
                          color="primary"
                          class="mr-2"
                          @click="loadAnexo(item, mode='update')"
                        >
                          mdi-square-edit-outline
                        </v-icon>
                        <v-icon
                          medium
                          color="error"
                          class="mr-2"
                          @click="loadAnexo(item, mode='delete')"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-card-actions class="justify-end">
                      <v-btn
                        color="success"
                        class="ml-1 mb-3"
                        v-if="codigo"
                        @click="loadModalAnexo"
                      >
                        <v-icon left>
                          mdi-archive-arrow-up-outline
                        </v-icon>
                        Add anexo
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions>
          <v-row class="mt-1">
            <v-col
              cols="12"
              md="6"
            >
              <v-btn
                color="success"
                class="ml-1 mr-4"
                v-if="mode === 'save'"
                @click.prevent="save"
              >
                <v-icon left>
                  mdi-content-save-outline
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="ml-1 mr-4"
                v-if="mode === 'update'"
                @click.prevent="save"
              >
                <v-icon left>
                  mdi-content-save-edit-outline
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="secondary"
                class="mr-4"
                @click="reset"
              >
                <v-icon left>
                  mdi-broom
                </v-icon>
                Limpar
              </v-btn>
              <v-btn
                v-if="sessao.id"
                color="error"
                class="mr-4"
                @click="remove"
              >
                <v-icon left>
                  mdi-trash-can-outline
                </v-icon>
                Deletar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <v-container>
        <v-dialog
          v-model="dialogFilter"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialogFilter">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar sessões
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headerSes"
                :items="sessoes"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    large
                    color="success"
                    class="mr-2"
                    @click.prevent="loadSessao(item)"
                  >
                    mdi-arrow-down-bold-box
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialogFilter.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Dialog de anexos -->
      <v-container>
        <v-dialog
          v-model="DialogAnexo"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              Adicionar ou editar anexos a sessão
            </v-toolbar>
            <div class="logo-foto ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="anexo.usuario"
                />
                <input
                  id="uuid-id"
                  type="hidden"
                  v-model="anexo.uuid"
                />
                <input
                  id="anexo-id"
                  type="hidden"
                  v-model="anexo.id"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codigo"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                    v-if="anexo.id"
                  >
                    <v-checkbox
                      v-model="anexo.inativar"
                      label="Inativar Documento?"
                      color="success"
                      class="mt-4"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                    lg="3"
                  >
                    <v-text-field
                      v-model="anexo.nome"
                      type="text"
                      label="Nome do arquivo"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                  >
                    <v-autocomplete
                      label="Tipo de documento:"
                      v-model="anexo.uid_tipodoc"
                      :items="anexos"
                      dense
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    lg="4"
                  >
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datanex"
                          v-model="data_anex"
                          label="Data de publicacao.:"
                          dense
                          outlined
                          @blur="mudaDataC"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date2"
                        @input="dateC"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row v-if="anexo.id">
                  <v-col
                    cols="12"
                    lg="8"
                  >
                    <v-text-field
                      v-model="anexo.url"
                      label="Limk do documento ou arquivo:"
                      class="mb-2"
                      dense
                      outlined
                    >
                      <v-btn
                        icon
                        tile
                        color="success"
                        :href="anexo.url"
                        target="_blank"
                        append
                        slot="append"
                      >
                        <v-icon large>
                          mdi-file-download
                        </v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="!anexo.id">
                  <input
                    accept="application/vnd.ms-excel, application/pdf"
                    prepend-icon="mdi-camera"
                    label="Anexo"
                    v-if="uploadReady"
                    type="file"
                    ref="file"
                    @change="selectFile()"
                  >
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="anexo.id"
                type="submit"
                @click.prevent="updateDoc()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!anexo.id"
                type="submit"
                @click.prevent="fileUpload()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="!anexo.id"
                @click="clearUpload"
              >
                deleter
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'sessaoMovin',
  computed: mapState(['user']),
  data: function () {
    return {
      errors: {},
      editor: ClassicEditor,
      editorConfig: {
      },
      databe: '##/##/####',
      datenc: '##/##/####',
      datanex: '##/##/####',
      mode: 'save',
      pagina: 'sessoes',
      tabs: null,
      codigo: '',
      btnOrdem: false,
      dialogFilter: false,
      DialogAnexo: false,
      DialogFornecedor: false,
      date0: new Date().toISOString().substr(0, 10),
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      data_abe: '',
      data_enc: '',
      data_anex: '',
      menu: false,
      menu1: false,
      menu2: false,
      search: null,
      uuid: '',
      uploadReady: true,
      file: '',
      arquivo: '',
      tabela: 'sessoesanexos',
      sessao: {},
      sessaoSinc: {},
      sessoes: [],
      vereadores: [],
      tipos: [],
      legislaturas: [],
      anexo: {},
      anexos: [],
      situacoes: [],
      ordem: {},
      ordens: [],
      loading: false,
      filter: null,
      filterOn: [],
      headerOrdem: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Id sessao', value: 'uid_sessao' },
        { text: 'Título', value: 'titulo' },
        { text: 'Data', value: 'datacriacao' },
        { text: 'Status', value: 'situacao' },
        { text: 'Seguir', value: 'actions', sortable: false }
      ],
      headerVereador: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'uid_vereador'
        },
        { text: 'Nome', value: 'nome' },
        { text: 'Presença', value: 'presenca' },
        { text: 'Tipo de justificação', value: 'uid_justificativa' },
        { text: 'Seguir', value: 'actions', sortable: false }
      ],
      justificativa: [
        { value: 1, text: 'Memorando' },
        { value: 2, text: 'Justificado' }
      ],
      headerSes: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Nº sessao', value: 'nr_sessao' },
        { text: 'Legislatura', value: 'legislatura' },
        { text: 'tipo de sessao', value: 'tipo' },
        { text: 'Título', value: 'titulo' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerAnexo: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Sessão', value: 'uid_sessao' },
        { text: 'Nome do arquivo', value: 'nome' },
        { text: 'Url', value: 'url' },
        { text: 'Tamanho', value: 'size' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      reunioes: [
        { value: 1, text: '1ª Reunião periódica' },
        { value: 2, text: '2ª Reunião periódica' },
        { value: 3, text: '3ª Reunião periódica' },
        { value: 4, text: '4ª Reunião periódica' },
        { value: 5, text: '5ª Reunião periódica' },
        { value: 6, text: '6ª Reunião periódica' },
        { value: 6, text: '7ª Reunião periódica' },
        { value: 6, text: '8ª Reunião periódica' },
        { value: 9, text: '9ª Reunião periódica' },
        { value: 10, text: '10ª Reunião periódica' },
        { value: 11, text: '11ª Reunião periódica' }
      ]
    }
  },
  methods: {
    mudaDataA () {
      const [dia, mes, ano] = this.data_abe.split('/')
      if (this.data_abe) {
        this.sessao.data_inicio = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateA () {
      this.data_abe = moment(this.date0).format('DD/MM/YYYY')
      this.menu = false
      const [dia, mes, ano] = this.data_abe.split('/')
      this.sessao.data_inicio = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataB () {
      const [dia, mes, ano] = this.data_enc.split('/')
      if (this.data_enc) {
        this.sessao.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateB () {
      this.data_enc = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
      const [dia, mes, ano] = this.data_enc.split('/')
      this.sessao.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataC () {
      const [dia, mes, ano] = this.data_anex.split('/')
      if (this.data_anex) {
        this.anexo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateC () {
      this.data_anex = moment(this.date2).format('DD/MM/YYYY')
      this.menu2 = false
      const [dia, mes, ano] = this.data_anex.split('/')
      this.anexo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    save () {
      const mode = this.mode
      const method = this.sessao.id ? 'put' : 'post'
      const id = this.sessao.id ? `/${this.sessao.id}` : ''
      axios[method](`${baseApiUrl}/sessao-plenaria${id}`, this.sessao)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          if (mode === 'save') {
            this.reset()
          }
        })
        .catch(showError)
    },
    remove () {

    },
    addOrdemDia () {
      this.ordem.uuid = uuid.v1()
      this.ordem.uid_sessao = this.sessao.id
      this.ordem.titulo = 'Anúncio da ordem do dia ' + moment(this.sessao.data_inicio).format('DD/MM/YYYY') + '.'
      this.ordem.ds_ordem = '<p>Anúncio da ordem do dia ' + moment(this.sessao.data_inicio).format('DD/MM/YYYY') + '.</p>'
      this.ordem.data_criacao = moment(this.sessao.data_inicio).format('YYYY-MM-DD')
      this.ordem.usuario = this.user.id
      const method = 'post'
      axios[method](`${baseApiUrl}/ordem-do-dia`, this.ordem)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadSessao()
          this.loadOrdens()
        })
        .catch(showError)
    },
    loadAddVereador () {
      const method = 'post'
      axios[method](`${baseApiUrl}/registro-de-presensa`, this.vereadores)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.sinc()
        })
        .catch(showError)
    },
    sinc () {
      const id = this.sessao.id
      const method = 'put'
      axios[method](`${baseApiUrl}/sessao-plenaria-sinc/${id}`, this.sessaoSinc)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadSessao()
        })
        .catch(showError)
    },
    updateDoc () {
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      axios[method](`${baseApiUrl}/anexos-de-sessoes${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.Limpar()
          this.loadAnexos()
          this.DialogAnexo = false
        })
        .catch(showError)
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/upload-documentos-em-anexo-da-sessao${id}`
      formData.append('uid_sessao', this.sessao.id)
      formData.append('uuid', this.anexo.uuid)
      formData.append('nome', this.anexo.nome)
      formData.append('legislatura', this.sessao.legislatura)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.sessao.ano)
      formData.append('subpasta', this.sessao.nr_sessao)
      formData.append('uid_tipodoc', this.anexo.uid_tipodoc)
      formData.append('data_publicacao', this.anexo.data_publicacao)
      formData.append('usuario', this.user.id)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
          this.loadAnexos()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    clearUpCampos () {
      this.anexo = {}
      this.file = ''
    },
    resetUpload () {
      this.anexo = {}
      this.file = ''
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    delete () {

    },
    FecharDialog () {
      this.DialogAnexo = false
      this.Limpar()
    },
    Limpar () {
      this.anexo = {}
      this.anexo.usuario = this.user.id
      this.anexo.uuid = uuid.v1()
    },
    reset () {
      this.mode = 'save'
      this.codigo = ''
      this.sessao = {}
      this.sessaoSinc = {}
      this.data_abe = ''
      this.data_enc = ''
      this.sessoes = []
      this.vereadores = []
      this.anexos = []
      this.ordens = []
      this.sessao.usuario = this.user.id
      this.sessao.uuid = uuid.v1()
    },
    loadSessao (item) {
      const id = this.codigo ? this.codigo : item.id
      const url = `${baseApiUrl}/sessao-plenaria-up/${id}`
      axios.get(url).then(res => {
        this.sessao = res.data
        this.codigo = this.sessao.id
        this.btnOrdem = this.sessao.id
        if (!this.sessao.data_inicio) {
          this.data_abe = ''
        } else {
          this.data_abe = moment(this.sessao.data_inicio).format('DD/MM/YYYY')
          this.sessao.data_inicio = moment(this.sessao.data_inicio).format('YYYY-MM-DD')
        }
        if (!this.sessao.data_encerramento) {
          this.data_enc = ''
        } else {
          this.data_enc = moment(this.sessao.data_encerramento).format('DD/MM/YYYY')
          this.sessao.data_encerramento = moment(this.sessao.data_encerramento).format('YYYY-MM-DD')
        }
        //        this.loadAnexos()
      })
      this.dialogFilter = false
    },
    loadModalAnexo () {
      this.anexo.usuario = this.user.id
      this.anexo.uuid = uuid.v1()
      this.DialogAnexo = true
      this.loadTipoAnexo()
    },
    loadAnexo (items, mode) {
      const id = items.id
      const url = `${baseApiUrl}/anexos-de-sessoes-up/${id}`
      axios.get(url).then(res => {
        this.anexo = res.data
        if (!this.anexo.data_publicacao) {
          this.data_anex = ''
        } else {
          this.data_anex = moment(this.anexo.data_publicacao).format('DD/MM/YYYY')
          this.anexo.data_publicacao = moment(this.anexo.data_publicacao).format('YYYY-MM-DD')
        }
      })
      this.mode = mode
      this.DialogAnexo = true
      this.loadTipoAnexo()
    },
    loadDialog () {
      this.dialogFilter = true
      this.loadFilter()
      this.reset()
    },
    loadFilter () {
      const url = `${baseApiUrl}/sessao-plenaria-filtro`
      axios.get(url).then(res => {
        this.sessoes = res.data
      })
    },
    loadVereadores () {
      const id = this.sessao.uid_legislatura
      const url = `${baseApiUrl}/select-vereadores-para-quorum/${id}`
      axios.get(url).then(res => {
        this.vereadores = res.data.map(item => {
          return {
            ...item,
            presenca: item.presenca !== null,
            uid_sessao: this.sessao.id,
            usuario: this.user.id
          }
        })
      })
      this.sessaoSinc.quorum = true
    },
    loadPresenca () {
      const id = this.sessao.id
      const url = `${baseApiUrl}/registro-de-presensa-para-quorun/${id}`
      axios.get(url).then(res => {
        this.presenca = res.data._vot
        this.sessao.presente = this.presenca.s
        this.ausencia = res.data.nao
        this.sessao.ausente = this.ausencia.n
      })
      this.loadSituacoes()
    },
    loadOrdens () {
      const id = this.sessao.id
      const url = `${baseApiUrl}/ordem-do-dia-sessao/${id}`
      axios.get(url).then(res => {
        this.ordens = res.data.map(item => {
          return {
            ...item,
            datacriacao: moment(item.data_criacao).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadSituacoes () {
      const url = `${baseApiUrl}/situacoes`
      axios.get(url).then(res => {
        this.situacoes = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.situacao}`
          }
        })
      })
    },
    loadAnexos () {
      const id = this.sessao.id
      const url = `${baseApiUrl}/anexos-de-sessoes-por-sessao/${id}`
      axios.get(url).then(res => {
        this.anexos = res.data
      })
    },
    loadTipoAnexo () {
      const url = `${baseApiUrl}/categoria-de-documentos`
      axios.get(url).then(res => {
        this.anexos = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.cat_doc}`
          }
        })
      })
    },
    loadTipo () {
      const url = `${baseApiUrl}/tipo-de-sessao`
      axios.get(url).then(res => {
        this.tipos = res.data.map(item => {
          return {
            value: item.id,
            text: item.tipo
          }
        })
      })
    },
    loadLegislaturas () {
      const url = `${baseApiUrl}/mandato-dos-vereadores`
      axios.get(url).then(res => {
        this.legislaturas = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.legislatura}ª Legislatura`
          }
        })
      })
    },
    loadUsers () {
      this.sessao.usuario = this.user.id
      this.sessao.uuid = uuid.v1()
    }
  },
  watch: {
    Filter () {
      // this.loadFilter()
    }
  },
  mounted () {
    this.loadUsers()
    this.loadTipo()
    this.loadLegislaturas()
  }
}
</script>
<style scoped>
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-size--default {
  height: 37px !important;
  min-width: 38px !important;
}
</style>
